var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-extraElement"},[(_vm.textEnable)?_c('f7-link',{attrs:{"href":_vm.info.urlDestiny}},[_vm._v("\n    "+_vm._s(_vm.info.text)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.iconEnable)?_c('f7-link',{attrs:{"href":_vm.info.urlDestiny}},[_c('f7-icon',{class:`icon-menu ${_vm.info.urlImage}`})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }